import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes'

import { createObjectSessionStore } from 'entities/kyrgyzstan/model/create-object'

import HomeImage from 'shared/images/home.webp'
import { Button } from 'shared/ui/button'
import { ImageOptimized } from 'shared/ui/image-optimized'

import s from './styles.module.scss'

const KyrgyzstanCreateObjectSubmittedPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    createObjectSessionStore.reset()
  }, [])

  const handleGoBack = () => {
    navigate(
      {
        pathname: RoutingPaths.kyrgyzstan.objects.path(),
        search: '?status=submitted',
      },
      {
        replace: true,
      },
    )
  }

  return (
    <main className={clsx('safe-area-top-padding', s.content)}>
      <ImageOptimized
        src={HomeImage}
        width={64}
        height={64}
        objectFit="contain"
      />
      <div>
        <h1 className={clsx(s.title, 'bold-24')}>
          {t('kyrgyzstan_block.create_object.submitted.title')}
        </h1>
        <p className={clsx(s.description, 'medium-14')}>
          {t('kyrgyzstan_block.create_object.submitted.description')}
        </p>
      </div>

      <Button
        className={clsx(s.button, 'bold-16')}
        onClick={handleGoBack}
        variant="grey"
      >
        {t('kyrgyzstan_block.create_object.submitted.button')}
      </Button>
    </main>
  )
}

export default KyrgyzstanCreateObjectSubmittedPage
